import { Injectable } from '@angular/core';
import { Observable ,  AsyncSubject } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import urlJoin from 'url-join';
import { SettingsService } from '../shared/services/settings/settings.service';
import { PayrollSchedule } from './payroll-schedule.model';
import { Moment } from 'moment';
import { ROUTE_TOKEN_GATEWAY_URL } from '../shared/interceptors/gateway-url.interceptor';


@Injectable()
export class PayrollScheduleService {

  public subject = new AsyncSubject<PayrollSchedule>();

  constructor(
    private http: HttpClient,
    private settings: SettingsService) {
      this._getPayrollSchedule()
      .subscribe(result => {
        this.subject.next(result);
        this.subject.complete();
      });
    }

  getPayrollSchedule(): Observable<PayrollSchedule> {
    return this.subject.asObservable();
  }

  private _getPayrollSchedule(minDate: Moment = null, maxDate: Moment = null): Observable<PayrollSchedule> {
    return this.http.get<PayrollSchedule>(this._getUri('payrollSchedule', this._getQueryParameters(minDate, maxDate)));
  }

  private _getUri(path: string, params: string) {
    let url = urlJoin(this._getBaseUrl(), `cui-payment/v1/tenants/${encodeURI(this.settings.tenantId)}/`);
    url = urlJoin(url, path);
    if (params) {
      url += '?' + params;
    }
    return url;
  }

  private _getQueryParameters(minDate: Moment, maxDate: Moment): string {
    return new HttpParams()
      .append('minDate', minDate ? minDate.toISOString() : '')
      .append('maxDate', maxDate ? maxDate.toISOString() : '')
      .toString();
  }

  private _getBaseUrl(): string {
    return ROUTE_TOKEN_GATEWAY_URL;
  }
}
